import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

class Color {
  create = async (color: any) => {
    await axios.post<any>(`${API_URL}item-color`, color)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  edit = async (color: any, code: any) => {
    await axios.put<any>(`${API_URL}item-color/${code}`, color)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  get = async (code: any) => {
    const response = await axios.get<any>(`${API_URL}item-color/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.color;
  };

  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}item-color`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.color;
  };
}

export default new Color();
